import { defineComponent as c, createElementBlock as i, openBlock as r, mergeProps as u, unref as o, renderSlot as l, createBlock as t, createCommentVNode as p } from "vue";
import a from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/FormControl/form-control.js";
import { CircleCheckIcon as f } from "../packages/icons/dist/esm/icons/circle-check-icon.js";
import { CircleExclamationIcon as d } from "../packages/icons/dist/esm/icons/circle-exclamation-icon.js";
import { TriangleExclamationIcon as I } from "../packages/icons/dist/esm/icons/triangle-exclamation-icon.js";
import { useOUIAProps as C } from "../helpers/ouia.js";
const h = /* @__PURE__ */ c({
  name: "PfFormControlIcon",
  __name: "FormControlIcon",
  props: {
    status: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(n) {
    const s = n, m = C({ id: s.ouiaId, safe: s.ouiaSafe });
    return (e, k) => (r(), i("span", u(o(m), {
      class: [o(a).formControlIcon, {
        [o(a).modifiers.status]: e.status
      }]
    }), [
      l(e.$slots, "default", {}, () => [
        e.status === "success" ? (r(), t(o(f), { key: 0 })) : e.status === "warning" ? (r(), t(o(d), { key: 1 })) : e.status === "error" ? (r(), t(o(I), { key: 2 })) : p("", !0)
      ])
    ], 16));
  }
});
export {
  h as default
};
